import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    // customer master state
    showDrawerCustomerMaster: false,
    formTypeCustomerMaster: "",
    initialValuesCustomerMaster: {},
    paginationCustomerMaster: {
        pageNo: 0,
        limit: 10,
        sortBy: "DESC",
        sortField: "created_at",
        keywords: "",
    },
    // selected customer master for details
    selectedCustomerMaster: null,
    showCustomerMasterDetails: false,
};

export const customerMasterSlice = createSlice({
    name: "customerMaster",
    initialState,
    reducers: {
        // customer master state
        changeCustomerMasterInitialState: (state, action) => {
            const { showDrawer, formType, initialValues } = action.payload;

            state.showDrawerCustomerMaster = showDrawer;
            if (formType) state.formTypeCustomerMaster = formType;
            if (initialValues) state.initialValuesCustomerMaster = initialValues;
            if (!initialValues) state.initialValuesCustomerMaster = {};
        },
        handlePaginationStateCustomerMaster: (state, action) => {
            const { payload } = action;
            state.paginationCustomerMaster = payload;
        },
        // customer master details
        setSelectedCustomerMaster: (state, action) => {
            state.selectedCustomerMaster = action.payload;
        },
        setShowCustomerMasterDetails: (state, action) => {
            state.showCustomerMasterDetails = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    changeCustomerMasterInitialState,
    handlePaginationStateCustomerMaster,
    setSelectedCustomerMaster,
    setShowCustomerMasterDetails,
} = customerMasterSlice.actions;

export default customerMasterSlice;
